var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import * as React from 'react';
import * as PropTypes from 'prop-types';
import { DropDownList } from '@progress/kendo-react-dropdowns';
import { provideLocalizationService, registerForLocalization } from '@progress/kendo-react-intl';
import { messages } from './../../messages';
/**
 * The EnumFilter component used for editing the value of FilterDescriptor object.
 * It renders a DropDownList and allows you to choose a value from the predefined list.
 */

var EnumFilter = function (_super) {
  __extends(EnumFilter, _super);

  function EnumFilter() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.onChange = function (event) {
      _this.props.onFilterChange.call(undefined, {
        nextFilter: __assign({}, _this.props.filter, {
          value: event.value.value
        })
      });
    };

    return _this;
  }
  /**
   * @hidden
   */


  EnumFilter.prototype.render = function () {
    var locService = provideLocalizationService(this);
    var _a = this.props,
        filter = _a.filter,
        _b = _a.data,
        data = _b === void 0 ? [] : _b,
        defaultItem = _a.defaultItem;
    var locData = data.map(function (item) {
      return __assign({}, item, {
        text: locService.toLanguageString(item.text, messages[item.text] || item.text)
      });
    });
    return React.createElement(DropDownList, {
      value: locData.find(function (i) {
        return i.value === filter.value;
      }) || null,
      onChange: this.onChange,
      defaultItem: defaultItem,
      data: locData,
      textField: "text"
    });
  };
  /**
   * @hidden
   */


  EnumFilter.propTypes = {
    filter: PropTypes.object.isRequired,
    onFilterChange: PropTypes.func.isRequired,
    data: PropTypes.arrayOf(PropTypes.shape({
      text: PropTypes.string,
      value: PropTypes.any
    })),
    defaultItem: PropTypes.any
  };
  return EnumFilter;
}(React.Component);

export { EnumFilter };
registerForLocalization(EnumFilter);